import { NgModule } from '@angular/core';
import { SearchBoxComponent } from './search-box.component';

@NgModule({
  imports: [SearchBoxComponent],
  exports: [SearchBoxComponent],
})
export class VaSearchBoxModule {}
